const getters = {
  isShowbgImg: state => state.app.isShowbg,
  getSelectDate: state => state.app.selectDate,
  isShowWarningBox: state => state.app.isShowWarningBox,
  visitedViews: state => state.tagsView.visitedViews,
  token: state => state.user.token,
  refreshToken: state => state.user.refreshToken,

}
export default getters
